<template #contentTemplate="{}">
  <div>
      <div v-if="open" class="modal--backdrop" @click="open = false"></div>
      <div v-if="open" class="card combobox">
        <div class="row ">
          <div class="text-input col-9">
            <!-- <label><b>Customer</b></label> -->
            <div class="input-group">
              <input 
                v-if="open"
                type="text"
                v-focus="true"
                class="form-control"
                placeholder="search..."  
                :style="{marginBottom: '10px'}"
                v-model="customInput"
                @input="debounce(customInputChanged, 500)"
                aria-label="Description">
            </div>
          </div>
          <div class="col">
            <button type="button" class="btn btn-primary" @click="$emit('toggleAddCustomerModal')">Add New Customer</button>
          </div>
        </div>
        <!-- <BasicTextInput 
          :customStyles="{marginBottom: '10px'}"
          label="Customer" placeholder="search..." :focus="true" @change="debounce(customInputChanged, 500)" v-model="customInput"/> -->
        <DxDataGrid
          ref="dataGrid"
          :data-source="dataSource"
          :height="300"
          width="100%"
          :row-alternation-enabled="true"
          :allow-column-resizing="true"
          :hover-state-enabled="true"
          :onRowClick="onSelectionChanged"
          :onRowPrepared="onRowPrepared"
          :onContentReady="onContentReady"
          :show-borders="true"

          :remoteOperations="true"
          key-expr="Name"
        >
          <DxFilterRow   :showOperationChooser="false" :visible="true"/>
          <!-- <DxFilterPanel   /> -->
          <!-- <DxHeaderFilter :visible="true" /> -->
          <DxSearchPanel :text="searchInput" :visible="false" :width="460"/>
          <!-- <DxColumn :width="50" data-field="Id" cell-template="grid-cell"/> -->
          <DxColumn :width="30" caption="" data-field="IsFavorite" cell-template="grid-cell-favorite" :allow-filtering="false"/>
          <DxColumn :width="90" caption="Customer #" data-field="JdeNum" cell-template="grid-cell"/>
          <DxColumn :width="200" data-field="Name" cell-template="grid-cell"/>
          <DxColumn :width="200" caption="City" data-field="Address.City" cell-template="grid-cell"/>
          <DxColumn :width="200" caption="Contact" data-field="CustomerContactName" cell-template="grid-cell"/>
          <DxColumn :width="30" caption="Private" data-field="IsPrivate" cell-template="grid-cell-private"/>
          <template  #grid-cell="{ data }">
            <div class="cell" style="fontSize:10px">{{ data.text }}</div>
          </template>
          <template  #grid-cell-private="{ data }">
              <div class="cell">
                <i :class="data.value ? 'fa fa-check' : 'fa fa-times'" aria-hidden="true"></i>
              </div>
          </template>
          <template #grid-cell-favorite="{ data }">
              <div class="cell favorite-cell" @click.stop="toggleFavorite(data.data, $event)">
                <i :class="data.value ? 'fas fa-star' : 'far fa-star'"
                   :style="{color: data.value ? 'orange' : 'gray', cursor: 'pointer'}"></i>
              </div>
          </template>
          <DxScrolling mode="virtual"/>
          <DxPaging
            :enabled="true"
            :page-size="50"
          />
        </DxDataGrid>
        <!-- <span class="my-2"></span> -->
        
        <!-- <span class="my-1"></span> -->
        
      </div>
    </div>
</template>
<script>

import {
  DxDataGrid,
  DxPaging,
  DxSelection,
  DxScrolling,
  DxColumn,
  DxSearchPanel,
  DxHeaderFilter,
  DxFilterPanel,
  DxFilterRow,
}                             from 'devextreme-vue/data-grid';
import DxDropDownBox          from 'devextreme-vue/drop-down-box';
import BasicTextInput         from '../components/inputComponents/BasicTextInput.vue';
import { CustomerService, CustomerFavoritesService }    from '@/services';
import { on, off }            from "devextreme/events";

const dropDownBoxRefName = 'customerSearchDropdown';

export default {
  components: {
    DxSearchPanel,
    DxDataGrid,
    DxPaging,
    DxSelection,
    DxScrolling,
    DxColumn,
    DxDropDownBox,
    DxHeaderFilter,
    DxFilterRow,
    DxFilterPanel,
  },
  props: {
    value: {
      type: String,
      default: null
    },
    onValueChanged: {
      type: Function,
      default: () =>  {}
    },
  },
  data() {
    return {
      dataSource: [],
      searchInput: '',
      open: false,
      currentValue: null,
      dropDownOptions: { width: 500 },
      dropDownBoxRefName,
      customInput: '',
      timerId: null,
    };
  },
  directives: {
    focus: {
      inserted: function (el, binding) {
        if(binding.value) el.focus()
      }
    }
  },
  methods: {

    debounce(func, wait) {
      //console.log('does this happen?')
      clearTimeout(this.timerId);
      this.timerId = setTimeout(func, wait)
    },

    onSelectionChanged(selectionChangedArgs) {
      if(!selectionChangedArgs) return;
      this.$emit('customerSelected', selectionChangedArgs.data)
      this.toggle()
    },

    toggle(){
        this.open = !this.open;
    },
    customInputChanged(){
        this.searchInput = this.customInput;
        this.currentValue = this.customInput;
        this.onValueChanged(this.currentValue)
      
      
    },
    getCustomers(){
      this.dataSource = CustomerService.getDataSource();
    },
    async toggleFavorite(customer, event) {
      const icon = event.currentTarget.querySelector('i');
      const wasFavorite = customer.IsFavorite;

      // Instant star toggle via DOM
      customer.IsFavorite = !wasFavorite;
      icon.className = customer.IsFavorite ? 'fas fa-star' : 'far fa-star';
      icon.style.color = customer.IsFavorite ? 'orange' : 'gray';

      try {
        if (wasFavorite) {
          await CustomerFavoritesService.removeFavorite(customer.Id);
        } else {
          await CustomerFavoritesService.addFavorite(customer.Id);
        }
        // Silently refresh sort order and separator (no load panel)
        const grid = this.$refs.dataGrid.instance;
        grid.option('loadPanel.enabled', false);
        grid.refresh().finally(() => {
          grid.option('loadPanel.enabled', true);
        });
      } catch (err) {
        customer.IsFavorite = wasFavorite;
        icon.className = wasFavorite ? 'fas fa-star' : 'far fa-star';
        icon.style.color = wasFavorite ? 'orange' : 'gray';
        console.error('Error toggling favorite:', err);
      }
    },
    onRowPrepared(e) {
      if (e.rowType === 'data') {
        e.rowElement.classList.remove('favorite-separator');
      }
    },
    onContentReady(e) {
      const rows = e.component.getVisibleRows();
      let lastFavoriteElement = null;
      for (const row of rows) {
        if (row.rowType === 'data' && row.data.IsFavorite) {
          const el = e.component.getRowElement(row.rowIndex);
          if (el && el[0]) lastFavoriteElement = el[0];
        }
      }
      if (lastFavoriteElement) {
        lastFavoriteElement.classList.add('favorite-separator');
      }
    },
  },
  // watch: {
  //   customInput: function() {
  //     console.log('happens')
  //   }
  // },
  created(){
    this.currentValue = this.value;
    this.getCustomers();
  },
};
</script>
<style lang="scss" scoped>
  .modal--backdrop {
    position: fixed;
    top: 0;
    left: 0;
    min-height: 100%;
    min-width: 100%;
    z-index: 100;
    opacity: 0;
    
  }
  .combobox {
    position: absolute;
    z-index: 100;
    width: 800px;
    height: 400px;
    padding: 20px;
    padding-bottom: 5px;
  }
  .header {
    color: $primary;
    font-size: 12px;
  }
  .cell {
    color: $ss_grey1;
    font-size: 10px;
  }
</style>

<style lang="scss">
  .favorite-separator {
    border-bottom: 3px solid #333 !important;
  }
</style>